// Imports: local files.
import {
    GET_ANALYTICS_OVERVIEW_START,
    GET_ANALYTICS_OVERVIEW_SUCCESS,
    GET_ANALYTICS_OVERVIEW_FAILED,
    GET_ANALYTICS_OVERVIEW_RESET,
    GET_ANALYTICS_REALTIME_START,
    GET_ANALYTICS_REALTIME_SUCCESS,
    GET_ANALYTICS_REALTIME_FAILED,
    GET_ANALYTICS_REALTIME_RESET,
    GET_ANALYTICS_USERS_LIFETIME_START,
    GET_ANALYTICS_USERS_LIFETIME_SUCCESS,
    GET_ANALYTICS_USERS_LIFETIME_FAILED,
    GET_ANALYTICS_USERS_LIFETIME_RESET,
    GET_ANALYTICS_USERS_BY_DAY_START,
    GET_ANALYTICS_USERS_BY_DAY_SUCCESS,
    GET_ANALYTICS_USERS_BY_DAY_FAILED,
    GET_ANALYTICS_USERS_BY_DAY_RESET,
    GET_ANALYTICS_USERS_SUMMARY_START,
    GET_ANALYTICS_USERS_SUMMARY_SUCCESS,
    GET_ANALYTICS_USERS_SUMMARY_FAILED,
    GET_ANALYTICS_USERS_SUMMARY_RESET,
    GET_ANALYTICS_REALTIME_SUMMARY_START,
    GET_ANALYTICS_REALTIME_SUMMARY_SUCCESS,
    GET_ANALYTICS_REALTIME_SUMMARY_FAILED,
    GET_ANALYTICS_REALTIME_SUMMARY_RESET,
    GET_ANALYTICS_EVENTS_START,
    GET_ANALYTICS_EVENTS_SUCCESS,
    GET_ANALYTICS_EVENTS_FAILED,
    GET_ANALYTICS_EVENTS_RESET,
  } from '../actions';
  
  const initialLoadingState = {
    loading: false,
    success: false,
    data: null,
    error: false,
    errorMessage: null,
  };
  
  const initialState = {
    overview: initialLoadingState,
    realtime: initialLoadingState,
    usersLifetime: initialLoadingState,
    usersByDay: initialLoadingState,
    usersSummary: initialLoadingState,
    realtimeSummary: initialLoadingState,
    events: initialLoadingState,
  };
  
  const analyticsReducer = (state = initialState, action) => {
    switch (action.type) {
      /**
       * =======================================================================
       * Analytics Overview
       * =======================================================================
       */
      case GET_ANALYTICS_OVERVIEW_START:
        return { ...state, overview: { ...action.payload } };
      case GET_ANALYTICS_OVERVIEW_SUCCESS:
        return { ...state, overview: { ...action.payload } };
      case GET_ANALYTICS_OVERVIEW_FAILED:
        return { ...state, overview: { ...action.payload } };
      case GET_ANALYTICS_OVERVIEW_RESET:
        return { ...state, overview: initialLoadingState };
  
      /**
       * =======================================================================
       * Analytics Realtime
       * =======================================================================
       */
      case GET_ANALYTICS_REALTIME_START:
        return { ...state, realtime: { ...action.payload } };
      case GET_ANALYTICS_REALTIME_SUCCESS:
        return { ...state, realtime: { ...action.payload } };
      case GET_ANALYTICS_REALTIME_FAILED:
        return { ...state, realtime: { ...action.payload } };
      case GET_ANALYTICS_REALTIME_RESET:
        return { ...state, realtime: initialLoadingState };
  
      /**
       * =======================================================================
       * Analytics Users Lifetime
       * =======================================================================
       */
      case GET_ANALYTICS_USERS_LIFETIME_START:
        return { ...state, usersLifetime: { ...action.payload } };
      case GET_ANALYTICS_USERS_LIFETIME_SUCCESS:
        return { ...state, usersLifetime: { ...action.payload } };
      case GET_ANALYTICS_USERS_LIFETIME_FAILED:
        return { ...state, usersLifetime: { ...action.payload } };
      case GET_ANALYTICS_USERS_LIFETIME_RESET:
        return { ...state, usersLifetime: initialLoadingState };
  
      /**
       * =======================================================================
       * Analytics Users By Day
       * =======================================================================
       */
      case GET_ANALYTICS_USERS_BY_DAY_START:
        return { ...state, usersByDay: { ...action.payload } };
      case GET_ANALYTICS_USERS_BY_DAY_SUCCESS:
        return { ...state, usersByDay: { ...action.payload } };
      case GET_ANALYTICS_USERS_BY_DAY_FAILED:
        return { ...state, usersByDay: { ...action.payload } };
      case GET_ANALYTICS_USERS_BY_DAY_RESET:
        return { ...state, usersByDay: initialLoadingState };
  
      /**
       * =======================================================================
       * Analytics Users Summary
       * =======================================================================
       */
      case GET_ANALYTICS_USERS_SUMMARY_START:
        return { ...state, usersSummary: { ...action.payload } };
      case GET_ANALYTICS_USERS_SUMMARY_SUCCESS:
        return { ...state, usersSummary: { ...action.payload } };
      case GET_ANALYTICS_USERS_SUMMARY_FAILED:
        return { ...state, usersSummary: { ...action.payload } };
      case GET_ANALYTICS_USERS_SUMMARY_RESET:
        return { ...state, usersSummary: initialLoadingState };
  
      /**
       * =======================================================================
       * Analytics Realtime Summary
       * =======================================================================
       */
      case GET_ANALYTICS_REALTIME_SUMMARY_START:
        return { ...state, realtimeSummary: { ...action.payload } };
      case GET_ANALYTICS_REALTIME_SUMMARY_SUCCESS:
        return { ...state, realtimeSummary: { ...action.payload } };
      case GET_ANALYTICS_REALTIME_SUMMARY_FAILED:
        return { ...state, realtimeSummary: { ...action.payload } };
      case GET_ANALYTICS_REALTIME_SUMMARY_RESET:
        return { ...state, realtimeSummary: initialLoadingState };
  
      /**
       * =======================================================================
       * Analytics Events
       * =======================================================================
       */
      case GET_ANALYTICS_EVENTS_START:
        return { ...state, events: { ...action.payload } };
      case GET_ANALYTICS_EVENTS_SUCCESS:
        return { ...state, events: { ...action.payload } };
      case GET_ANALYTICS_EVENTS_FAILED:
        return { ...state, events: { ...action.payload } };
      case GET_ANALYTICS_EVENTS_RESET:
        return { ...state, events: initialLoadingState };
  
      default:
        return state;
    }
  };
  
  export default analyticsReducer;